import styled, { css } from "styled-components"

export const Container = styled.div`
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);

    position: fixed;
    top: 0;
    right: 0;
    z-index: -9;
    opacity: 0;

    transition: all 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #535354;

    ${props => props.modalFormsMainIsOpen && css`
        opacity: 1;
        z-index: 999;
    `}
`

export const Content = styled.div`
    height: 90vh;
    width: 100%;
    max-width: 700px;
    padding: 4rem;
    background: #FFF;
    border-radius: 10px;
    position: relative;
    overflow-y: auto;
    
    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;

    button{
        margin-top: 3rem;
    }

    @media (max-width: 700px){
        height: 100%;
        border-radius: 0;
        padding: 3rem 1rem;
    }
`

export const Form = styled.div`
    margin-top: 2rem;

    h3{
        margin: 2rem 0;
    }

    .dateInputs{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 2rem 0;

        p{
            font-weight: 500;
            font-size: 1.2rem;
            margin: 0.5rem 1rem;
        }

        @media (max-width: 480px){
            justify-content: center;
            flex-direction: column;
        }
    }

    .inputText{
        display: flex;
        align-items: center;
    }

    .backgrounds, .fonts{
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 4rem;

        div{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
    
            p{
                font-weight: 900;
            }
        }

        .colorInput{
            border: none;
            background: transparent;
            height: 3rem;
            width: 6rem;
            cursor: pointer;
    
            &::-webkit-color-swatch{
                border-radius: 10px;
                border: 3px solid #000;
            }
        }
    }
`

export const ImageUploader = styled.div`
    margin-top: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .imageArea{
        width: 80%;
        height: 8rem;
        border: ${props => props.img ? 'none' : '2px dashed #CCC'};
        border-radius: 10px;
        position: relative;
        overflow: hidden;

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        @media (max-width: 375px) {
            width: 100%
        }


        img{
            height: 100%;
            width: 100%;
            position: absolute;
            object-fit: contain;
            display: ${props => props.img ? 'block' : 'none'};
        }
       

        svg{
            color: #7A05A7;
            font-size: 5rem;
        }

        div{
            position: absolute;
            bottom: 0;
            width: 100%;
            text-align: center;
            color: #FFF;
            background: linear-gradient(135deg, #d10089 0%, #7A05A7 100%);
            padding: 0.5rem 0;
            font-size: 1.2rem;
            transform: translateY(100%);
            z-index: 9;
            transition: transform 0.3s ease;
        }

        .closeButton{
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 1.2rem;
            color: #7A05A7;
            transform: translateY(-150%);
            z-index: 9;
            transition: transform 0.3s ease;
            cursor: pointer;
        }

        ${props => props.img && css`
            &:hover{
                .closeButton, div{
                    transform: translateY(0);
                }
            }
        `}
    }

    button{
        border: none;
        padding: 0.75rem 0;
        margin: 1rem 0;
        width: 80%;
        color: #FFF;
        background: linear-gradient(135deg, #d10089 0%, #7A05A7 100%);
        font-size: 1rem;
        border-radius: 15px;
        font-weight: 500;
        letter-spacing: 1px;
        outline: none;

        @media (max-width: 375px) {
            width: 100%
        }
    }
`